var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"page-title-layout"},[_c('div',[(_vm.iconClass)?_c('span',{staticClass:"icon",class:_vm.iconClass}):_vm._e(),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.title))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4feaf92d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/page-title.vue
// module id = null
// module chunks = 